import { HubSpotEventNames } from '@fsp-lib/shared/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hubspotQueue = (window as any)._hsq;

export interface HubSpotEvent {
  name: string;
}

export const sendEventToHubspot = function (name: string) {
  const hubspotEvent: HubSpotEvent = {
    name: `${HubSpotEventNames.prefix}${name}`,
  };

  if (hubspotQueue) {
    hubspotQueue.push(['trackCustomBehavioralEvent', hubspotEvent]);
  }
};
